"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const ChartContext_1 = require("../context/ChartContext");
const scale_1 = require("./utilities/scale");
const lineStyle = (0, react_1.css) `
  stroke: green;
  stroke-width: 2;
  opacity: 0.5;
`;
function SignalDeltaLine({ delta, axis, show }) {
    const { xDomain, yDomain } = (0, ChartContext_1.useChartData)();
    const scaleX = (0, scale_1.useScale2DX)();
    const scaleY = (0, scale_1.useScale2DY)();
    if (!show)
        return null;
    if (axis === 'X') {
        return ((0, jsx_runtime_1.jsx)("line", { css: lineStyle, x1: scaleX(delta), x2: scaleX(delta), y1: scaleY(yDomain[0]), y2: scaleY(yDomain[1]) }, `signalLine_${delta}_X`));
    }
    if (axis === 'Y') {
        return ((0, jsx_runtime_1.jsx)("line", { css: lineStyle, x1: scaleX(xDomain[0]), x2: scaleX(xDomain[1]), y1: scaleY(delta), y2: scaleY(delta) }, `signalLine_${delta}_Y`));
    }
}
exports.default = SignalDeltaLine;
